@defer (when rows() && dataTable()) {
  <header>
    @if (canFilterByAssetType()) {
      <app-data-table-filter-types [sensorTypes]="sensorTypes()" (onSensorTypeSelected)="sensorTypeChange($event)"></app-data-table-filter-types>
    }
  </header>
  <table class="table" [class.table-hover]="canClick()" [class.no-top-border]="noTopBorder()" [class.is-mobile]="isMobile">
    <thead>
      <tr>
        @for (column of dataTable().columns; track column.attribute; let i = $index) {
          <!-- Onlt show header if not hidden or has a title -->
          @if (!column.isHidden) {
            @if (column.title !== '') {
              <th [width]="column.width ? column.width + 'px' : ''" [class.no-padding]="column.padding === 0 || column.dataType === 'rag'">
                <div (click)="sortColumnClick(column)">
                  <div>
                    @if (column.title !== 'RAG') {
                      <span [title]="column.tooltip" [tooltipPosition]="column.tooltipPosition ?? 'top'">{{ column.title }}</span>
                    } @else {
                      <!-- RAG title supressed-->
                    }
                  </div>
                  <div>
                    <i [title]="column.sortDirection === 'asc' ? 'Ascending, click to sort descending' : column.sortDirection === 'desc' ? 'Descending, click to sort ascending' : 'Not sorted, click to sort ascending'" class="mdi" [class.mdi-sort-ascending]="column.sortDirection === 'asc'" [class.mdi-sort-descending]="column.sortDirection === 'desc'" [class.mdi-sort-reverse-variant]="column.sortDirection !== 'asc' && column.sortDirection !== 'desc'"></i>
                  </div>
                </div>
              </th>
            } @else {
              <!-- if no title, still set width but no sorting -->
              <th [class.no-padding]="column.padding === 0" [width]="column.width ? column.width + 'px' : ''" class="no-click">
                <div></div>
              </th>
            }
          }
        }
        @if (actions()) {
          <th></th>
        }
      </tr>
    </thead>

    <tbody>
      @for (row of rows(); track dataRowTracking(row)) {
        <tr (click)="rowClick($event, row)" [class.is-disabled]="row?.isEnabled === false || row?.isActive === false" [class.is-in-alert]="row?.isInAlert === true">
          @for (column of dataTable().columns; track column; let i = $index) {
            @if (!column.isHidden) {
              @switch (column.dataType) {
                @case ('rag') {
                  <td class="rag-{{ row[column.attribute] }}"></td>
                }
                @case ('yn') {
                  <td class="text-{{ dataTable().dataClassConfig[column.attribute].align }}">{{ row[column.attribute] === 'Y' ? 'Yes' : 'No' }}</td>
                }
                @case ('boolean') {
                  <td class="text-{{ dataTable().dataClassConfig[column.attribute].align }}">{{ row[column.attribute] ? 'Yes' : 'No' }}</td>
                }
                @case ('image') {
                  <td>
                    @if (row[column.attribute]) {
                      @switch (column.dataFormat) {
                        @case ('logo') {
                          <img class="logo" src="https://s3.eu-west-2.amazonaws.com/4d-documents/{{ row[column.attribute] }}" alt="logo" />
                        }
                      }
                    }
                  </td>
                }
                @case ('date') {
                  <!-- prettier-ignore -->
                  @switch(column.dataFormat) {
                   @case ('time') {
                       <td class="text-{{ dataTable().dataClassConfig[column.attribute].align }}">{{ row[column.attribute] | date:'HH:mm' }}</td>
                    }
                    @case ('date') {
                       <td class="text-{{ dataTable().dataClassConfig[column.attribute].align }}">
                        @if(row[column.attribute] ) {  
                                                
                      {{ row[column.attribute] | date:'dd/MM/yy' }}
                      }
                      </td>
                    }
                    @default {
                      <td class="text-{{ dataTable().dataClassConfig[column.attribute].align }}" [class.no-padding]="column.padding === 0">{{ row[column.attribute] | date:'dd/MM/yy HH:mm' }}</td>
                    }
                   }
                }
                @default {
                  @switch (column.dataFormat) {
                    @case ('secret') {
                      <td class="text-{{ dataTable().dataClassConfig[column.attribute].align }} secret">
                        <div><span> reveal </span></div>
                        <span>{{ row[column.attribute] }}</span>
                      </td>
                    }
                    @default {
                      <td class="text-{{ dataTable().dataClassConfig[column.attribute].align }}" [class.opaque7]="dimZeros() && column.dataType === 'number' && row[column.attribute] === 0">
                        @if (canSelect() && i === 0) {
                          <app-tick [selected]="row.selected"></app-tick>
                        }
                        {{ row[column.attribute] }}
                      </td>
                    }
                  }
                }
              }
            }
          }
          @if (actions()) {
            <td>
              <div class="actions">
                @for (action of actions(); track $index) {
                  <span (click)="actionClick($event, action, row)">
                    @switch (action.type) {
                      @case ('update') {
                        <i class="mdi mdi-pencil can-click" title="Update" tooltipPosition="left"></i>
                      }
                      @default {
                        <i class="{{ action - icon }} can-click"> </i>
                      }
                    }
                  </span>
                }
              </div>
            </td>
          }
        </tr>
      }
    </tbody>

    @if (footerTotals()) {
      <tfoot>
        <tr>
          @for (column of dataTable().columns; track column.attribute; let i = $index) {
            @if (!column.isHidden) {
              <td class="text-{{ dataTable().dataClassConfig[column.attribute].align }}">{{ footerTotals()[i] }}</td>
            }
          }
        </tr>
      </tfoot>
    }
  </table>
} @placeholder {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}
